import { useUser } from './useUser';

export const useIsGuestUser = () => {
  const {
    user: { accessToken, isLoggedIn, isMember }
  } = useUser();

  return { isGuestUser: Boolean(accessToken) && !isLoggedIn, isMember };
};
